export const USER_AVAILABILITY = [
  { value: 'available', viewValue: 'Available' },
  { value: 'ooo', viewValue: 'Out of Office' },
] as const;

export const USER_STATUS = [
  { value: 'activated', viewValue: 'Active', class: 'status-box-green' },
  { value: 'deactivated', viewValue: 'Inactive', class: 'status-box-contrast' },
] as const;

export const USER_ROLE = [
  { value: 'rm', viewValue: 'RM', isMaker: false, isChecker: false, isLeader: false, icimbMemberRole: false },
  {
    value: 'rm-manager',
    viewValue: 'RM Manager',
    isMaker: false,
    isChecker: false,
    isLeader: false,
    icimbMemberRole: false,
  },
  { value: 'rm-head', viewValue: 'RM Head', isMaker: false, isChecker: false, isLeader: false, icimbMemberRole: false },

  {
    value: 'credit-officer',
    viewValue: 'Credit Officer',
    isMaker: false,
    isChecker: false,
    isLeader: false,
    icimbMemberRole: false,
  },
  {
    value: 'credit-manager',
    viewValue: 'Credit Manager',
    isMaker: false,
    isChecker: false,
    isLeader: false,
    icimbMemberRole: false,
  },

  /* ASD */
  {
    value: 'icimb-asd',
    viewValue: 'iCIMB ASD',
    isMaker: false,
    isChecker: false,
    isLeader: false,
    icimbMemberRole: true,
  },
  {
    value: 'icimb-asd-leader',
    viewValue: 'iCIMB ASD Leader',
    isMaker: false,
    isChecker: false,
    isLeader: true,
    icimbMemberRole: false,
  },

  /* DOC */
  {
    value: 'icimb-doc-maker',
    viewValue: 'iCIMB Doc Maker',
    isMaker: true,
    isChecker: false,
    isLeader: false,
    icimbMemberRole: true,
  },
  {
    value: 'icimb-doc-checker',
    viewValue: 'iCIMB Doc Checker',
    isMaker: false,
    isChecker: true,
    isLeader: false,
    icimbMemberRole: true,
  },
  {
    value: 'icimb-doc-leader',
    viewValue: 'iCIMB Doc Leader',
    isMaker: false,
    isChecker: false,
    isLeader: true,
    icimbMemberRole: false,
  },

  /* FIN */
  {
    value: 'icimb-fin',
    viewValue: 'iCIMB Fin Maker',
    isMaker: true,
    isChecker: false,
    isLeader: false,
    icimbMemberRole: true,
  },
  {
    value: 'icimb-fin-checker',
    viewValue: 'iCIMB Fin Checker',
    isMaker: false,
    isChecker: true,
    isLeader: false,
    icimbMemberRole: false,
  },
  {
    value: 'icimb-fin-leader',
    viewValue: 'iCIMB Fin Leader',
    isMaker: false,
    isChecker: false,
    isLeader: true,
    icimbMemberRole: false,
  },

  /* Limit */
  {
    value: 'icimb-limit',
    viewValue: 'iCIMB Limit Maker',
    isMaker: true,
    isChecker: false,
    isLeader: false,
    icimbMemberRole: true,
  },
  {
    value: 'icimb-limit-checker',
    viewValue: 'iCIMB Limit Checker',
    isMaker: false,
    isChecker: true,
    isLeader: false,
    icimbMemberRole: false,
  },
  {
    value: 'icimb-limit-leader',
    viewValue: 'iCIMB Limit Leader',
    isMaker: false,
    isChecker: false,
    isLeader: true,
    icimbMemberRole: false,
  },

  /* DDM */
  {
    value: 'icimb-ddm',
    viewValue: 'iCIMB DDM',
    isMaker: false,
    isChecker: false,
    isLeader: false,
    icimbMemberRole: true,
  },
  {
    value: 'icimb-ddm-leader',
    viewValue: 'iCIMB DDM Leader',
    isMaker: false,
    isChecker: false,
    isLeader: true,
    icimbMemberRole: false,
  },

  {
    value: 'product-manager',
    viewValue: 'Product Manager',
    isMaker: false,
    isChecker: false,
    isLeader: false,
    icimbMemberRole: false,
  },
  {
    value: 'sale-support',
    viewValue: 'Sale Support',
    isMaker: false,
    isChecker: false,
    isLeader: false,
    icimbMemberRole: false,
  },
  { value: 'admin', viewValue: 'Admin', isMaker: false, isChecker: false, isLeader: false, icimbMemberRole: false },

  // External
  { value: 'broker', viewValue: 'Broker', icimbMemberRole: false, isMaker: false, isChecker: false, isLeader: false },
  // { value: 'personnel', viewValue: 'Personnel', icimbMemberRole: false },
] as const;

// export const USER_ROLE_VALUE = USER_ROLE.map(role => role.value);
export const USER_ROLE_VALUE_SET = new Set(USER_ROLE.map(role => role.value));
export const ICIMB_MEMBER_ROLE = USER_ROLE.filter(role => role.icimbMemberRole === true);

// V2
export const ICIMB_LEADER_ROLE = USER_ROLE.filter(role => role.isLeader).map(role => role.value);
export const ICIMB_MAKER_ROLE = USER_ROLE.filter(role => role.isMaker).map(role => role.value);
export const ICIMB_CHECKER_ROLE = USER_ROLE.filter(role => role.isChecker).map(role => role.value);

export const ICIMB_LEADER_ROLE_SET = new Set(USER_ROLE.filter(role => role.isLeader).map(role => role.value));
export const ICIMB_MAKER_ROLE_SET = new Set(USER_ROLE.filter(role => role.isMaker).map(role => role.value));
export const ICIMB_CHECKER_ROLE_SET = new Set(USER_ROLE.filter(role => role.isChecker).map(role => role.value));
